import { useEffect, useState } from 'react'

import service from '@/utils/service'

/**
 * 需要隐藏的私密信息（ORG: 组织信息，TIME: 打卡时间，ADDRESS: 打卡地址）
 */
export enum PRIVATE_MODE_CODE {
  ORG = 'EMPLOYEE_ORG_SHOW',
  TIME = 'ATTENDANCE_EMPLOYEE_CLOCK_TIME_SHOW',
  ADDRESS = 'ATTENDANCE_EMPLOYEE_CLOCK_ADDRESS_SHOW'
}
export default function usePrivateMode(code: PRIVATE_MODE_CODE, defaultValue: boolean = true) {
  const [privateMode, setPrivateMode] = useState(defaultValue)
  const getPrivateMode = async () => {
    const { success, data } = (await service({
      url: `/system/senior_param/detail?code=${code}`,
      method: 'get'
    })) as any
    if (success) {
      setPrivateMode(data === '0')
    }
  }
  useEffect(() => {
    getPrivateMode()
  }, [])
  return { privateMode, setPrivateMode }
}
